import type { Person } from '../api/use-people.js';
import type { Waiver } from '../api/use-waivers.js';
import { ConsentBox } from './consent-box.js';

/**
 * The waiver on the hour screen (ruled 13 October; mockup *Waiver on Booking*).
 *
 * One card per chosen child whose signature is not on the waiver in force, under
 * that child's name: the wording changed since they were signed for, or they
 * never were. Children already on the current wording show nothing, and the
 * account holder is never asked here.
 *
 * The line above the card is Matthew's wording, verbatim (RE-27).
 */
export function BookingWaivers({
  people,
  waiver,
  guardian,
  approved,
  onChange,
  missing,
}: {
  /** Only the chosen children who need it; the screen decides who. */
  people: Person[];
  waiver: Waiver;
  guardian: string;
  approved: string[];
  onChange: (clientId: string, next: boolean) => void;
  /** Children the parent tried to add without approving. */
  missing: string[];
}) {
  return (
    <>
      {people.map((person) => (
        <div key={person.client_id} className="booking-waiver">
          <span className="section-label">Waiver for {person.first_name}</span>
          <p className="consent-why">
            {person.waiver_signed_at
              ? `Our waiver has been updated since you signed it for ${person.first_name}, please read and approve it again.`
              : `No waiver signed for ${person.first_name} yet. Read it and approve.`}
          </p>
          <ConsentBox
            id={`waiver-${person.client_id}`}
            waiver={waiver}
            guardian={guardian}
            athlete={`${person.first_name} ${person.last_name}`}
            checked={approved.includes(person.client_id)}
            onChange={(next) => onChange(person.client_id, next)}
            error={missing.includes(person.client_id) ? 'Approve before adding.' : null}
            required
          />
        </div>
      ))}
    </>
  );
}
